import { CircularProgress } from '@mui/material'

export const CardLoading = () => {
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <CircularProgress />
    </div>
  )
}
